import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from 'src/app/auth/auth.service';
import { Observable } from 'rxjs';
import { parse } from 'url';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { AppInitializationService } from 'src/app/shared/services/app-initialization.service';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private appConfigService: AppConfigService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.domainIsWhitelisted(request) && this.authService.auth0SDKIntialised) {
      return this.authService.getNewToken().pipe(
        switchMap((token) => {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(request);
        })
      );
    } else {
      return next.handle(request);
    }
  }

  domainIsWhitelisted(request: HttpRequest<any>) {
    var requestUrl = parse(request.url, false, true);

    // We make an exception for the loading the environment settings.
    // We can't use the config service until then.
    return (
      requestUrl.pathname !== '/build-info.json' &&
      (requestUrl.pathname === AppInitializationService.EnvironmentSettingsLocation ||
        requestUrl.hostname.includes(this.appConfigService.config.whitelistedDomain))
    );
  }
}
